import { Box, Button, Typography } from "@mui/material";
import BlockIcon from '@mui/icons-material/Block';
import React from "react";

export default function NoAccess() {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <BlockIcon color="error" sx={{ fontSize: 100, marginBottom: 2 }} />
            <Typography variant="h3" sx={{ marginBottom: 2, textAlign: 'center', fontFamily: 'Trebuchet MS', width: '100%', fontSize: 'clamp(1.5rem, 1.5rem, 1.5rem)' }}>You don't have access to this page.</Typography>
            <Button variant="text" color="primary" sx= {{ textTransform: 'capitalize', fontSize: 'clamp(1rem, 1rem, 1rem)' }} onClick={() => window.location.href = '/'}>Go to Dashboard</Button>
        </Box>
    )
}